<template>
  <div class="app-error">
    <div class="app-error__content">
      <h4>{{ message }}</h4>
      <p>{{ url }}</p>
      <template v-if="isOnline()">
        <h3>The OECD API is unreachable at this moment. Please, go back to the previous indicator or try again later.</h3>
        <a
          v-if="showReturn"
          class="app-error__breadcrumb btn"
          @click="onClickBreadcrumb"
        >Return</a>
      </template>
      <template v-else>
        <h3>It seems that you are offline. Pleas check your Internet connection and try again.</h3>
        <a
          class="app-error__breadcrumb btn"
          @click="refresh"
        >Reload</a>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: ['message', 'url', 'breadcrumb'],
  computed: {
    showReturn () {
      return this.isExploreLayout
    }
  },
  methods: {
    isOnline() {
      return navigator.onLine
    },
    refresh() {
      location.reload()
    },
    onClickBreadcrumb() {
      this.$router.push({path: this.breadcrumb || '/'})
    }
  }
}
</script>

<style lang="stylus">
.app-error__content
  background: white
  border-radius: 10px
  bottom: 0
  box-shadow: 0 0 20px #0002
  display: flex
  flex-direction: column
  height: min-content
  left: 0
  margin: auto
  max-width: 500px
  padding: 1em 2em
  position: absolute
  right: 0
  text-align: center
  top: 0
  overflow-wrap: break-word;

h4
  margin-bottom: 0

h4
  color: #ec6f6f

h3
  color: $blue

p
  margin: .5em 0
  font-size: .8em
  opacity: 0.6

a.btn
  margin: 1em 0
  border-radius: 5px

  .layout-embedded
    display: none

</style>
